import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
// Importando componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';

import { Container } from './styles';

export default function Padrao({ match }) {
  const inputRef = useRef(null);
  const [carregar, setCarregar] = useState(false);

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      const { id } = match.params;
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required('Preencha o campo name'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post(`produto/${id}/padrao`, {
        name: data.name,
      });

      toast.success('Padrão cadastrado com sucesso');
      history.push(`/produto-edit/${id}`);
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao cadastrar padrão verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  return (
    <Container>
      <h4>Cadastrar Padrão</h4>
      <span>Bem-vindo ao LeadFlow</span>
      <Card>
        <Form ref={inputRef} onSubmit={handlerSubmit} autoComplete="off">
          <Input icon="MdPerson" label="Nome" name="name" type="text" />
          <Button tamanho="40px" load={carregar}>
            Cadastrar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

Padrao.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};
